<template>
  <div>
    <a-modal v-model="visible" width="660px" :title="domainId ? '修改业务域' : '添加业务域'" ok-text="确认" cancel-text="取消" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="close">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="名称" prop="name">
          <a-input v-model="modalForm.name" />
        </a-form-model-item>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="负责人" prop="owner" :label-col="{ span: 11 }" :wrapper-col="{ span: 13 }">
              <user-select v-model="modalForm.owner" placeholder="负责人" show-search />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="权重" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
              <a-input-number v-model="modalForm.weight" style="width: 100%" :min="1" :max="10000" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="所属项目" prop="project_id" :label-col="{ span: 11 }" :wrapper-col="{ span: 13 }">
              <a-select v-model="modalForm.project_id" placeholder="所属项目">
                <a-select-option v-for="(item, index) in projectData" :key="index" :value="item.id">{{ item.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="所属团队" prop="team_id" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
              <a-select v-model="modalForm.team_id" placeholder="所属团队">
                <a-select-option v-for="(item, index) in teamData" :key="index" :value="item.id">{{ item.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="成员">
          <user-select v-model="modalForm.members" mode="multiple" placeholder="成员" show-search allow-clear />
        </a-form-model-item>
        <a-form-model-item label="描述">
          <a-textarea v-model="modalForm.description" :auto-size="{ minRows: 3 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { domainAdd, domainModify } from '@/api/system/domain';
import { projectList } from '@/api/project/project';
import { teamList } from '@/api/system/team';

import UserSelect from '@/components/User/UserSelect';

export default {
  name: 'TeamModal',
  components: { UserSelect },
  props: {
    domainId: {
      type: [Number, String],
      default: null
    },
    domainData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      modalForm: {
        name: null,
        description: null,
        project_id: null,
        team_id: null,
        logo: null,
        members: []
      },
      teamData: [],
      projectData: [],
      rules: {
        name: [{ required: true, message: '业务域名称不能为空', trigger: 'blur' }],
        owner: [{ required: true, message: '业务域负责人不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.getProjectList();
        this.getTeamList();
        if (this.domainId) {
          this.modalForm = {
            logo: this.domainData.logo,
            name: this.domainData.name,
            description: this.domainData.description,
            project_id: this.domainData.project_id,
            team_id: this.domainData.team_id,
            owner: this.domainData.owner.id,
            weight: this.domainData.weight,
            members: this.domainData.members.map(item => {
              return item.id;
            })
          };
        } else {
          this.modalForm = {};
        }
      }
    }
  },
  methods: {
    close() {
      this.loading = false;
      this.$emit('close');
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uplaadLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        this.uplaadLoading = false;
        const { code, message, data } = info.file.response;
        if (code === 2000) {
          this.modalForm.logo = data.resource_url;
        } else {
          this.$message.warning(message);
        }
      }
    },

    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projectData = res.data.projects;
      });
    },

    // 获取团队列表
    getTeamList() {
      teamList({}).then(res => {
        this.teamData = res.data.items;
      });
    },

    submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.domainId) {
            domainModify({ id: this.domainId, ...this.modalForm })
              .then(() => {
                this.$message.success('修改成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            domainAdd(this.modalForm)
              .then(() => {
                this.$message.success('添加成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
